import { User } from '../../domains/app';

export interface QualificationContainerState {
  listQualifications: Qualification[];
}

export interface Qualification {
  id: string;
  accreditedDate: string | Date;
  isSuspended: boolean;
  personId: string;
  person: User;
  grantedByPersonId: string;
  grantedByPerson: User;
  testTypeId: string;
  testType: {
    id: string;
    name: string;
  };
  level: QualificationLevel;
}

export enum QualificationLevel {
  Tester = 0,
  Instructor = 1,
}
